import SelectWarehouse from './src/main'

SelectWarehouse.install = function (Vue) {
    Vue.component(SelectWarehouse.name, SelectWarehouse)
}

export default SelectWarehouse